import { defineMessages } from 'react-intl';
import { useFormatMessage } from '@alltrails/core/hooks/useFormatMessage';
import AlertDialog from '@alltrails/denali/components/AlertDialog';
import type { JSX } from 'react';

export type LightboxDeletePhotoAlertDialogProps = {
  onDeleteAlertClose: () => void;
  onPhotoDeleteHandle: () => void;
};

const messages = defineMessages({
  deletePhotoTitle: { defaultMessage: 'Delete photo' },
  areYouSure: { defaultMessage: 'Are you sure you want to delete this photo? ' },
  deletePhoto: { defaultMessage: 'Delete' },
  goBack: { defaultMessage: 'Go back' }
});

const DeletePhotoAlertDialog = ({ onDeleteAlertClose, onPhotoDeleteHandle }: LightboxDeletePhotoAlertDialogProps): JSX.Element => {
  const {
    formattedDefaultMessages: { deletePhotoTitle, areYouSure, deletePhoto, goBack }
  } = useFormatMessage(messages);

  return (
    <AlertDialog
      title={deletePhotoTitle}
      body={areYouSure}
      buttons={{
        primary: {
          onClick: onPhotoDeleteHandle,
          text: deletePhoto,
          testId: 'lightbox-delete-photo'
        },
        flat: {
          onClick: onDeleteAlertClose,
          text: goBack,
          testId: 'lightbox-delete-photo-go-back'
        }
      }}
      size="sm"
      onRequestClose={onDeleteAlertClose}
    />
  );
};

export default DeletePhotoAlertDialog;
